// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Newsletter_wrapper__ctg7Q","message":"Newsletter_message__2_PHW","form":"Newsletter_form__2Y1y6","input":"Newsletter_input__3ef-K","submit":"Newsletter_submit__1vTYs"};